export enum Target {
	none = 0,
	web = 1 << 0,
	desktop = 1 << 1,
	docportal = 1 << 2,
	static = 1 << 3,
	all = (1 << 0) | (1 << 1) | (1 << 2) | (1 << 3),
}

export enum Level {
	app = 1 << 0,
	workspace = 1 << 1,
	catalog = 1 << 2,
}

export type SettingEntry<T> = {
	target: Target;
	default: T | null;
	availableAt: Level;
	clientOverridable: boolean;
};

type SettingDefinition<T> = Partial<Omit<SettingEntry<T>, "availableAt">> & { availableAt: Level };

export const setting = <T>(e: SettingDefinition<T>): SettingEntry<T> => ({
	target: e.target ?? Target.all,
	default: e.default ?? null,
	availableAt: e.availableAt,
	clientOverridable: e.clientOverridable ?? false,
});
